export default __webpack_public_path__ + "static/media/blackX.d8c7d40d.svg";